import {Grid, Stack} from '@mui/material';
import {AppControlledInput} from 'components/form';
import React from 'react';
import {FieldsRendererProps} from '../FieldsRenderer';

interface RenderTextProps extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderText: React.FC<RenderTextProps> = ({field, control, gridSize, baseFieldName}) => {
    // const {getItemDataValueWithFormulaApplied} = useItemDataHelper();
    // const [readOnlyValue, setReadOnlyValue] = useState<string>();
    // useEffect(() => {
    //     if (field.formula && field.formula !== '') {
    //         const value = getItemDataValueWithFormulaApplied(field, itemSummaryVariables ?? []);

    //         if (value && field.isReadOnly) {
    //             setValue(`data.${indexKey}`, {
    //                 ...field,
    //                 value: {
    //                     ...field.value,
    //                     value: value,
    //                 },
    //             });
    //         } else {
    //             setReadOnlyValue(value);
    //         }
    //     } else {
    //         setReadOnlyValue(field.value?.value);
    //     }
    // }, [field.formula]);

    // const inputValue = readOnlyValue ?? '';
    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <AppControlledInput
                    label={field.title}
                    type="text"
                    fullWidth
                    // value={inputValue}
                    name={`${baseFieldName}.value`}
                    control={control}
                    // withCustomSetValue={true}
                    required={field.isRequired}
                    placeholder={field.placeHolder}
                />
            </Stack>
        </Grid>
    );
};

export default RenderText;
